// BLOG ARTICLE PAGE - For table of content and mobile subscription form display
if (window.location.href.indexOf('/blogs/') > -1) {
  const join = document.querySelector(".show_form");
  const form = document.querySelector(".mobile_subscribe_now");

  if (join) {
    join.addEventListener('click', () => {
      form.classList.toggle("active");
    });
  }

  const createTable = (sourceId, targetId) => {
    if (document.getElementById(sourceId)) {
      const sections = Array.from(document.getElementById(sourceId).children);
      const newTableDiv = document.getElementById(targetId);
      let newTable = "<ol>";
      sections.forEach((section, i) => {
        const sectionNumber = i + 1;
        newTable += `<li><a class='smooth_scroll' href='#section${sectionNumber}'>${section.innerText}</a></li>`;
      });
      newTable += "</ol>";
      newTableDiv.innerHTML = newTable;
    }
  };

  createTable("table", "new_table");
  createTable("table", "mobile_table");

  document.querySelectorAll('.smooth_scroll[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        if (window.innerWidth <= 989) {
            offset = 80;
        } else {
            offset = 100;
        }
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
}
